const ApiAttributesKeys = {
  chapterIdKey: 'chapterId',
  chapterNameKay: 'chapterName',
  totalReadingKey: 'totalReading',
  freeQuestionsCountKey: 'totalFreeQuestions',
  premiumQuestionsCountKey: 'totalQuestions',
  questionTableKey: 'question',
  readingIdKey: 'reading_id_2025', //*The key is associated with another table, which is why we cannot modify it.
  chapterOrderKey: 'chapterOrder',
};
module.exports = ApiAttributesKeys;



// WEBPACK FOOTER //
// ./src/views/CFA1-2025/QuestionBank/ApiAttributesKeys.js